import React, { useState, useEffect, useContext } from 'react';
import { AuthContext } from "../../AuthContext";
import { TableRecapData } from "../RecapUserData/TableRecapData";
import { TableRowAddress } from "../RecapUserData/TableRowAddress";
import { TableRowService } from "../RecapUserData/TableRowService";
import ProgressBar from 'react-bootstrap/ProgressBar';
import { GdacsTimeline } from "../Layout/GdacsTimeline";
import { useViewPort } from "../Hooks/useViewPort";
import ReCAPTCHA from 'react-google-recaptcha';

const UserRecapData = (props) => {
    const authContext = useContext(AuthContext);
    const params = props.params;
    const [checkedItems, setCheckedItems] = React.useState();
    // const [code, setCode] = useState("");
    const now = 60;
    const [navIndex, setNavIndex] = React.useState(props.navIndex);
    const { width } = useViewPort();
    const breakpoint = 620;

    const handleChange = (e) => {
        setCheckedItems({
            ...checkedItems,
            [e.target.name]: e.target.checked
        });
        if (props.handleCheck)
            props.handleCheck(e.target.checked);
    };

    const handleOtpChange = (e) => {

        console.log("VALUE", e.target.value);

        props.onChange({
            ...props.params,
            codeotp: e.target.value
        });
    };


    return (
        <div>
            <form>
                <h4 className="d-flex justify-content-center hr-title">Confirm Data Account</h4>
                <br />
                {width > breakpoint &&
                    <GdacsTimeline navIndex={navIndex} user={params.idUser} />
                }
                {width < breakpoint &&
                    <>
                        {props.params.idUser === 0 &&
                            <ProgressBar>
                                <ProgressBar variant={"YOU_PICK_A_NAME"} now={20}  />
                                <ProgressBar variant={"YOU_PICK_A_NAME"} now={20}  />
                                <ProgressBar variant={"YOU_PICK_A_NAME"} now={20}  />
                                <ProgressBar variant={"YOU_PICK_A_NAME"} now={20}  />
                                <ProgressBar variant={"YOU_PICK_A_NAME"} now={20} label={5} />
                            </ProgressBar>
                        }
                        {props.params.idUser !== 0 &&
                            <ProgressBar>
                                <ProgressBar variant={"YOU_PICK_A_NAME"} now={25}  />
                                <ProgressBar variant={"YOU_PICK_A_NAME"} now={25}  />
                                <ProgressBar variant={"YOU_PICK_A_NAME"} now={25}  />
                                <ProgressBar variant={"YOU_PICK_A_NAME"} now={25} label={4} />
                            </ProgressBar>
                        }
                    </>
                }
                <br />
                <br />
                <div>
                    <TableRecapData params={props.params} />
                    <TableRowAddress params={props.params} />
                    <TableRowService params={props.params} />
                    <br />
{/*                     <div className="row">
                        <div className="col-6">
                            <label
                                htmlFor="codeInput"
                                style={{ fontSize: "14px" }}
                            >
                                Code
                            </label>
                            <input
                                id="codeInput"
                                type="text"
                                className="form-control"
                                value={props.params.codeotp || ""}
                                maxLength={10}
                                onChange={handleOtpChange}
                                placeholder="Insert code OTP"
                            />
                        </div>
                        <div className="col-6">
                            {props.params?.idUser === 0 && (
                                <>
                                    <label style={{ fontSize: "14px" }}>
                                        Security Verification
                                    </label>

                                    <ReCAPTCHA
                                        sitekey={process.env.REACT_APP_SITE_KEY}
                                        ref={props.captchaRef}
                                        onChange={props.handleCaptchaChange}
                                    />
                                </>
                            )}
                        </div>
                    </div> */}

                    {props.params?.idUser === 0 && (
                        <div className="row">
                                <div className="col-6">
                                    <label
                                        htmlFor="codeInput"
                                        style={{ fontSize: "14px" }}
                                    >
                                        Code
                                    </label>

                                    <input
                                        id="codeInput"
                                        type="text"
                                        className="form-control"
                                        value={props.params.codeotp || ""}
                                        maxLength={10}
                                        onChange={handleOtpChange}
                                        placeholder="Insert code OTP"
                                    />

                                    {props.otpError && (
                                        <div className="input-feedback text-danger">
                                            {props.otpError}
                                        </div>
                                    )}
                                </div>

                                <div className="col-6">
                                    <label style={{ fontSize: "14px" }}>
                                        Security Verification
                                    </label>

                                    <ReCAPTCHA
                                        sitekey={process.env.REACT_APP_SITE_KEY}
                                        ref={props.captchaRef}
                                        onChange={props.handleCaptchaChange}
                                    />
                                </div>
                        </div>
                        )}
                    <br/>
                    <div className="p_summary" style={{ fontSize: "14px" }}> <div style={{ marginBottom: "14px" }}><b>Conditions for use:</b></div>

                        <b>Automated notifications:</b> GDACS notifications are produced automatically by computer algorithms without human
                        intervention. Errors may occur and the user agrees that information must not be used for decision‑making unless it is
                        validated independently. <b>Purpose of the service:</b> The service is offered for disaster‑monitoring purposes. <b>Data handling:</b> The
                        personal data you provide when registering will be used solely for the purposes of sending notifications and for internal usage
                        statistics. Your data will not be disclosed to third parties, except where such disclosure is necessary to fulfil the purposes
                        described above or where required by law. Your data will be retained for a period of one year after you have unregistered from
                        the system, after which it will be permanently deleted. <b>Data protection:</b> Processing of personal data is carried out in
                        accordance with the European Commission’s data‑protection policy (reference <a href="http://ec.europa.eu/dpo-register/detail/DPR-EC-00240" target="_blank">DPR-EC-00240.1</a>.). <b>Account termination:</b>
                        GDACS reserves the right to terminate or suspend any user account, without prior notice, in the event of misuse, abuse or
                        breach of these conditions. For <b>further details</b> see <a href="/Documents/GDACS_Terms_of_use.pdf" target="_blank">Terms of use</a> ; for enquiries contact <a href="/About/contactus.aspx" target="_blank">us</a>.
                    </div>
                    <br />
                    <div className="col-12 row" style={{ flexWrap: "nowrap" }}>
                        <input type='checkbox' aria-label="Checkbox for following text input" onClick={handleChange} style={{ maxWidth: "20px", marginLeft: "10px", marginTop: "5px" }} /> &nbsp;
                        <label style={{ fontSize: "14px", maxWidth: "-moz-fit-content" }}>    Accept Conditions for use</label>
                    </div>
                </div>
            </form>
        </div>
    )
}
export { UserRecapData }